module.exports = __webpack_public_path__ + "static/img/a3.aca624e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/a3.png
// module id = KPZH
// module chunks = 1